import { useEffect, useState } from "react";
import { t } from "@/i18n-js/instance";

const REFRESH_INTERVAL = 2000;

export const PlayerStats = ({ player }) => {
  const playerStats = player?.tech_?.vhs?.stats || {};
  const [bandwidth, setBandwidth] = useState(0);
  const [droppedFrames, setDroppedFrames] = useState(0);
  const [totalFrames, setTotalFrames] = useState(0);

  const fetchStats = stats => {
    setBandwidth((stats.bandwidth / 1000).toFixed(0));
    setDroppedFrames(stats.videoPlaybackQuality.droppedVideoFrames);
    setTotalFrames(stats.videoPlaybackQuality.totalVideoFrames);
  };

  useEffect(() => {
    if (!playerStats) return;

    fetchStats(playerStats);

    const interval = setInterval(() => {
      fetchStats(playerStats);
    }, REFRESH_INTERVAL);

    return () => clearInterval(interval);
  }, [playerStats]);

  if (!playerStats) {
    return null;
  }

  return (
    <div className="absolute bottom-6 left-6 z-20 flex flex-col rounded-md bg-gray-800/80 px-3 py-2 text-xs text-gray-100">
      <div>{t("live_streams.stats.bandwidth", { bandwidth })}</div>
      <div>{t("live_streams.stats.dropped_frames", { droppedFrames })}</div>
      <div>{t("live_streams.stats.total_frames", { totalFrames })}</div>
    </div>
  );
};
